import cn from "classnames";
import React, { useEffect, useState } from "react";
import { clearLogo, editLogo, getLogo } from "sources/profile/organization";

export default function OrgLogo(props) {
    const [loading, setLoading] = useState(true);
    const [logo, setLogo] = useState();
    const loadLogo = () => {
        getLogo().then((res) => {
            setLogo(res || undefined);
            setLoading(false);
        });
    };
    useEffect(() => {
        loadLogo();
    }, []);
    const addFile = () => {
        return props.modal({
            name: "fileUpload",
            accept: ".svg",
            propName: "file",
            title: "Загрузка файла",
            uploadFile: (params) => {
                setLoading(true);

                return editLogo(params);
            },
            action: (uploadedFiles) => {
                if (uploadedFiles?.length > 0) {
                    loadLogo();
                } else {
                    setLoading(false);
                }
            },
        });
    };
    const removeFile = () => {
        props.modal({
            name: "confirm",
            title: "Удаление логотипа",
            text: "Вы уверены, что хотите удалить логотип?",
            action: () => {
                setLoading(true);
                clearLogo().then(loadLogo);
            },
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };
    return (
        <div className="field-wrap--value row mb-2">
            <label className="col-form-label col-form-label-sm col-12 text-muted">
                Логотип компании для мобильного приложения
            </label>
            <div className={cn("col-12 d-flex align-items-baseline", { "loading loading--small": loading })}>
                {logo ? (
                    <div className="mr-2">
                        <img src={logo} className="profile-body__image" alt="Логотип компании" />
                    </div>
                ) : (
                    <div />
                )}
                <div className="btn btn-secondary btn-xs" onClick={addFile}>
                    {logo ? "Изменить файл" : "Добавить файл"}
                </div>
                {logo && (
                    <div className="ml-2 btn btn-xs btn-outline-danger" onClick={removeFile}>
                        Удалить файл
                    </div>
                )}
            </div>
            <div className="col-12">
                <small>
                    <i className="text-info">Только файлы формата .svg</i>
                </small>
            </div>
        </div>
    );
}
